<template>
  <CardModule class="mt-6" title="Dados Financeiros">
    <v-row>
      <v-col cols="6">
        <v-radio-group
          v-model="$loja_gerenciar.cadastro.dados_bancarios.tipo_conta"
        >
          <template v-slot:label>
            <span>Conta:</span>
          </template>
          <v-radio
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
            label="Conta Corrente"
            value="CORRENTE"
          ></v-radio>
          <v-radio
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
            label="Conta Poupança"
            value="POUPANCA"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col cols="6">
        <BaseTextField
          label="Nome do titular"
          placeholder="Insira o nome do titular"
          v-model="$loja_gerenciar.cadastro.dados_bancarios.nome_titular"
          type="text"
        >
        </BaseTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseAutocomplete
          label="Banco"
          :items="$config.bancos.result"
          placeholder="Selecione o banco"
          v-model="$loja_gerenciar.cadastro.dados_bancarios.banco"
          item-text="banco_nome"
          item-value="banco_codigo"
          :filter="search"
        >
          <template v-slot:selection="{ item }">
            <div v-if="item ? (bancos = item) : null">
              {{ item.banco_codigo }} - {{ item.banco_nome }}
            </div>
          </template>
        </BaseAutocomplete>
      </v-col>
      <v-col cols="6">
        <BaseTextField
          label="Agência"
          placeholder="Insira o nº da agência"
          v-model="$loja_gerenciar.cadastro.dados_bancarios.agencia"
          type="text"
          v-mask="['XXXXXXXXXXXXXXX']"
        >
        </BaseTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseTextField
          label="Número da conta"
          placeholder="Insira o nº da conta"
          v-model="$loja_gerenciar.cadastro.dados_bancarios.numero_conta"
          type="text"
          v-mask="['XXXXXXXXXXXXXXX']"
        ></BaseTextField>
      </v-col>
      <v-col cols="6">
        <BaseTextField
          label="Dígito"
          placeholder="Insira o digito"
          v-model="$loja_gerenciar.cadastro.dados_bancarios.digito_conta"
          type="text"
          v-mask="'XXXXXXXXXXXXXXX'"
        >
        </BaseTextField>
      </v-col>
    </v-row>
    <h1 class="lojas-gerenciar-dados-cadastrais-subtitle">
      Informações de Pagamento
    </h1>
    <v-divider></v-divider>
    <v-row class="mt-3 mb-5">
      <v-col cols="4" v-if="isAdmin">
        <BaseTextField
          label="Loja Neo Pay"
          placeholder="Insira o id da loja do neo pay"
          v-model="$loja_gerenciar.cadastro.dados_cadastrais.idloja_neo"
          type="text"
          :disabled="idNeoPayIsDisabled"
        >
        </BaseTextField>
      </v-col>
      <v-col cols="4">
        <BaseSelect
          label="Tipo de forma de pagamento"
          :items="tipoFormaPag"
          item-text="value"
          item-value="key"
          placeholder="Selecione o tipo de forma de pagamento"
          v-model="$loja_gerenciar.cadastro.dados_bancarios.tipo_forma_pag"
          type="text"
        >
        </BaseSelect>
      </v-col>
      <v-col cols="4">
        <BaseAutocomplete
          v-model="$loja_gerenciar.cadastro.dados_bancarios.forma_pag"
          :items="FormaPag"
          label="Selecione as formas de pagamento"
          :filter="searchForm"
          chips
          color="blue-grey lighten-2"
          item-text="descricao"
          item-value="idforma_pag"
          multiple
          needSelection
          no-data-text="Nenhuma forma de pagamento encontrada"
        >
          <template v-slot:selection="{ item }">
            {{ item.descricao }},
          </template>
          <template v-slot:item="{ item }">
            {{ item.descricao }}
          </template>
        </BaseAutocomplete>
      </v-col>
      <v-col cols="12">
        <BaseAutocomplete
          chips
          small-chips
          required
          multiple
          deletable-chips
          :search-input.sync="SearchBandeiras"
          @change="clearInput"
          label="Selecione as bandeiras aceitas"
          item-text="text"
          item-value="value"
          no-data-text="Nenhuma informação encontrada"
          v-model="$loja_gerenciar.cadastro.dados_bancarios.bandeiras"
          :items="$loja_gerenciar.bandeirasPgto"
          :rules="[rules.requiredArray]"
        >
          <template v-slot:selection="{ item }"> {{ item.text }}, </template>
          <template v-slot:item="{ item }"> {{ item.text }} </template>
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <template v-if="formaPagTable">
      <h1 class="lojas-gerenciar-dados-cadastrais-subtitle">
        Formas de Pagamento
      </h1>
      <v-divider></v-divider>
      <formaPag />
    </template>
  </CardModule>
</template>
<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import formaPag from "@/views/producers/FormasDePagamento.vue";
import _ from "lodash";
import mixins from "../../mixins";
const { formRules } = mixins;
export default {
  name: "lojas-gerenciar-dados-bancarios",
  mixins: [LojasGerenciarMixins, formRules],
  components: {
    formaPag,
    CardModule: () => import("@/components/cards/CardModule.vue"),
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    BaseAutocomplete: () => import("@/components/forms/BaseAutocomplete.vue"),
    BaseSelect: () => import("@/components/forms/BaseSelect.vue"),
  },
  data() {
    return {
      idNeoPayIsDisabled: false,
      SearchBandeiras: "",
    };
  },
  computed: {
    formaPagTable() {
      return (
        this.$loja_gerenciar.lojaAddOrEdit == "edit" &&
        this.$loja_gerenciar.cadastro.dados_bancarios.tipo_forma_pag ===
          "CUSTOM"
      );
    },
    tipoFormaPag() {
      if (this.$loja_gerenciar.lojaAddOrEdit == "new") {
        return this.$loja_gerenciar.cadastro.tipoFormaPagamento.filter(
          item => item.key != "CUSTOM"
        );
      } else {
        return this.$loja_gerenciar.cadastro.tipoFormaPagamento;
      }
    },
    FormaPag() {
      return _.orderBy(
        this.$loja_gerenciar.lista_forma_pagamento_loja,
        [forma_pag => forma_pag.descricao.toLocaleLowerCase()],
        ["descricao"]
      );
    },
    idLojaNeoIsEmpty() {
      if (
        this.$loja_gerenciar.cadastro.dados_cadastrais.idloja_neo === null ||
        this.$loja_gerenciar.cadastro.dados_cadastrais.idloja_neo ===
          undefined ||
        this.$loja_gerenciar.cadastro.dados_cadastrais.idloja_neo === ""
      ) {
        return true;
      }

      return false;
    },
  },
  watch: {
    "$loja_gerenciar.cadastro.dados_bancarios.tipo_forma_pag"(e) {
      this.$loja_gerenciar.cadastro.dados_bancarios.forma_pag = [];
      if (e === "DEFAULT") {
        this.$loja_gerenciar.getFormasPagLojaDefault();
      } else {
        this.$loja_gerenciar.sequenciador =
          this.$loja_gerenciar.cadastro.dados_bancarios.loja;
        this.$loja_gerenciar.getFormasPagLoja(
          this.$loja_gerenciar.sequenciador
        );
      }
    },
  },
  methods: {
    clearInput() {
      this.SearchBandeiras = "";
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.banco_nome.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    searchForm(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.descricao.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },
  mounted() {
    if (
      this.$loja_gerenciar.cadastro.dados_bancarios.tipo_forma_pag === "DEFAULT"
    ) {
      this.$loja_gerenciar.getFormasPagLojaDefault();
    } else {
      this.$loja_gerenciar.sequenciador =
        this.$loja_gerenciar.cadastro.dados_bancarios.loja;
      this.$loja_gerenciar.getFormasPagLoja(this.$loja_gerenciar.sequenciador);
    }
    if (this.idLojaNeoIsEmpty) {
      this.$loja_gerenciar.cadastro.dados_bancarios.bandeiras = [];
    }
    if (!this.idLojaNeoIsEmpty) {
      this.idNeoPayIsDisabled = true;
    }
  },
};
</script>
<style scoped>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
.lojas-gerenciar-dados-cadastrais-subtitle {
  width: 487px;
  font-size: 1rem;
  align-self: flex-start;
  margin-top: 1.25rem;
}
</style>
